import component from './components/Component';

export default component;
